module.exports = __webpack_public_path__ + "img/rock-huge-18.2193d465.png";